import { render, staticRenderFns } from "./OverviewWrapper.vue?vue&type=template&id=7f8b0c07&lang=pug&"
import script from "./OverviewWrapper.vue?vue&type=script&lang=js&"
export * from "./OverviewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OverviewWrapper.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports